export default __webpack_public_path__ + "static/media/YAS0120.34I-27677_-16599_0.2631da4c.jpg";